import { useEffect, useRef, useState } from "react";
import PageContainer from "shared/components/pagecontainer/PageContainer";
import styles from "./ConfirmarEmail.module.scss";
import { CircleArrowUp, Lock } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { cognitoConfirmSignUp } from "shared/services/aws/cognito";

export const ConfirmarEmail: React.FC = () => {

  const navigate = useNavigate();

  const location = useLocation();

  const email = location.state?.email || "";

  const [codigo, setCodigo] = useState([
    "",
    "",
    "",
    "",
    "",
    "",
  ]);

  const [loading, setLoading] = useState(false);

  const [tempo, setTempo] = useState(107);

  const inputsRef = useRef<
    Array<HTMLInputElement | null>
  >([]);

  useEffect(() => {

    if (tempo <= 0) return;

    const interval = setInterval(() => {
      setTempo((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);

  }, [tempo]);

  function handleChange(
    value: string,
    index: number
  ) {

    if (!/^\d?$/.test(value)) return;

    const novoCodigo = [...codigo];

    novoCodigo[index] = value;

    setCodigo(novoCodigo);

    if (value && index < 5) {
      inputsRef.current[index + 1]?.focus();
    }
  }

  async function handleConfirmar() {

    const codigoFinal = codigo.join("");

    if (codigoFinal.length < 6) {

      alert("Digite o código completo");

      return;
    }

    setLoading(true);

    try {

      await cognitoConfirmSignUp(
        email,
        codigoFinal
      );

      alert("Conta confirmada com sucesso!");

      navigate("/login");

    } catch (error: any) {

      console.error(error);

      alert(
        error?.message ||
        "Erro ao confirmar código"
      );

    } finally {

      setLoading(false);
    }
  }

  const minutos = Math.floor(tempo / 60);

  const segundos = tempo % 60;

  return (
    <PageContainer title="Código de Verificação" icon={<Lock size={18}/>} contentClassName={styles.whiteContent}>
      <div className={styles.page}>
        <div className={styles.containerCircle}>
          <CircleArrowUp size={20}  className={styles.circleIcon}/>
        </div>
        <div className={styles.containerTitulo}>
          <h2 className={styles.titulo}>Código enviado! </h2>
          <p className={styles.subTitulo}>Verifique sua caixa de entrada e spam.</p>
        </div>
        <div className={styles.codigoContainer}>
          <div className={styles.codigos}>

          {codigo.map((item, index) => (

            <input
              key={index}
              ref={(el) =>
                (inputsRef.current[index] = el)
              }
              value={item}
              maxLength={1}
              onChange={(e) =>
                handleChange(
                  e.target.value,
                  index
                )
              }
              className={styles.inputCodigo}
            />

          ))}
          </div>
          <p className={styles.timer}>
            Reenviar código em

            <span>
              {String(minutos).padStart(2, "0")}:
              {String(segundos).padStart(2, "0")}
            </span>
          </p>
        </div>
        
        <div className={styles.instrucoes}>
          <h4 className={styles.titulo}>Próximos Passos</h4>
          <p>1. Entre no seu e-mail<br/>2. Verifique sua caixa de entrada e spam<br/>
          3. Digite o codigo de verificação acima</p>
        </div>  
        <button
          onClick={handleConfirmar}
          className={styles.btnConfirmar}
          disabled={loading}
        >

          {loading
            ? "Confirmando..."
            : "Confirmar código e ativar conta"}

        </button>
        <div className={styles.containerLink}>
          <div className={styles.hrConfirmar}>
            Não recebeu o código?
          </div>
          <div>
          <button className={styles.btnReenviar}>Reenviar e-mail</button>
          </div>
        </div>
        
      </div>
    </PageContainer>
  );
};